import './LogIn.css';

import React, {useState} from "react";
import {faEye, faEyeSlash} from "@fortawesome/free-regular-svg-icons";
import {faUser, faLock} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {LogInState} from "../types";
import {authService} from "../services/authService";
import {useAuth} from "../hooks/useAuth";
import Header from "shared/components/Header/Header";

enum LogInStatus{
    NotSent,
    WaitingForResponse,
    IncorrectLoginOrPassword,
    NetworkError
}

const Login = () => {
    const { setLoggedIn, setRole, setMyUserId } = useAuth();

    const [login, setLogin] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [showPassword, setShowPassword] = useState(false);

    const [logInStatus, setLogInStatus] = useState<LogInStatus>(LogInStatus.NotSent);
    const [networkError, setNetworkError] = useState<number>(0);
    
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault(); 
        setLogInStatus(LogInStatus.WaitingForResponse);
        authService.logIn(login.trim(), password.trim()).then(response => {
            if (response.errorCode){
                setNetworkError(response.errorCode);
                setLogInStatus(LogInStatus.NetworkError);
            } else if (!response.success) {
                setLogInStatus(LogInStatus.IncorrectLoginOrPassword);
            } else {
                setRole(response.role);
                setMyUserId(response.user_id);
                setLoggedIn(response.dfs_token_active? LogInState.LoggedIn : LogInState.TokenExpired);
            }
        });
    };

    const handleSignUp = () => {
        const dfs_access_token = prompt("Enter your VIPER access token (Authorization header without 'Basic' word):");
        if (dfs_access_token !== null && dfs_access_token.length > 0) {
            authService.signUp(dfs_access_token).then(resp => {
                if (resp.errorCode !== undefined) {
                    alert(`Error: ${resp.errorCode}`);
                } else if (resp.success) {
                    alert(`Well done, ${resp.username}! Now you can authorize with your VIPER credentials!`);
                } else if (resp.username) {
                    alert(`User ${resp.username} already exists with such VIPER access token!`)
                } else {
                    alert('Invalid VIPER access token!')
                }
            });
        } else {
            alert("Can not create an account without VIPER access token!");
        }
    }
    
    const form_is_unfilled = login === "" || password === "";
    
    return (
        <div className="login-page">
            <Header logOut={false} help={true} />
            <div className="login-form-area">
                <h2 className="subheading">Log In</h2>
                <div className="form-container">
                    <form className='form' onSubmit={handleSubmit}>
                        <label htmlFor="inputField"><FontAwesomeIcon icon={faUser} className="form-icon"/>Login:</label>
                        <input type="text"
                               id="login"
                               value={login}
                               disabled={logInStatus === LogInStatus.WaitingForResponse}
                               onChange={(event) => {
                                   setLogin(event.target.value);
                                   setLogInStatus(LogInStatus.NotSent);
                               }}
                        />
                        <label htmlFor="inputField"><FontAwesomeIcon icon={faLock} className="form-icon"/>Password:</label>
                        <input type={showPassword ? 'text' : 'password'}
                               id="password"
                               value={password}
                               disabled={logInStatus === LogInStatus.WaitingForResponse}
                               onChange={(event) => {
                                   setPassword(event.target.value);
                                   setLogInStatus(LogInStatus.NotSent);
                               }}
                        />
                        <p className="show-password" onClick={() => setShowPassword(prev => !prev)}>
                            <FontAwesomeIcon icon={showPassword? faEyeSlash : faEye} className="form-icon"/>
                            {showPassword ? 'Hide Password' : 'Show Password'}
                        </p>
                        <p className="info-text-mini">
                            {logInStatus === LogInStatus.WaitingForResponse ?
                                "Waiting for response..." : ""}
                        </p>
                        <p className="error-text-mini">
                            {(login || password) && form_is_unfilled ?
                                "Please, fill all the fields" :
                                logInStatus === LogInStatus.IncorrectLoginOrPassword ?
                                    "Incorrect credentials!" :
                                    logInStatus === LogInStatus.NetworkError ?
                                        `Error: ${networkError}` : ""
                            }
                        </p>
                        <button className="button green-button" type="submit"
                                disabled={form_is_unfilled || logInStatus === LogInStatus.WaitingForResponse}>Log In
                        </button>
                        <p className="info-text-mini">or <span className="info-link-mini" onClick={handleSignUp}>Sign Up</span></p>
                    </form>
                </div>
                <div className="filler"></div>
            </div>
        </div>
    );
};

export default Login;